'use strict';

module.exports = function (win) {
  win = win || global;

  return win.document.characterSet.toLowerCase() === 'utf-8';
};



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web-drop-in/lib/is-utf-8.js
// module id = 337
// module chunks = 0